export const reportBarWidth = (showFilters, showExport) =>
  (showFilters ? 110 : 0) + (showExport ? 40 : 0)

export const reportsBarWidthMobile = (showFilters, showExport) =>
  (showFilters ? 50 : 0) + (showExport ? 40 : 0)
